import Form from "@scripts/components/Form/Form";


const componentMapping = {
  "form": Form,
};

export default componentMapping;
